<template>
  <proa-modal
    :modal="modal"
    :title="title"
    size="lg"
    noDefaultBodyPadding
    @close="close"
  >
    <iframe
      ref="paymentMethodFormIframe"
      :src="iframeSrc"
      :class="['payment-method-form-iframe', { 'disabled': innerRequesting || requesting }]"
    ></iframe>
    <template slot="footer">
      <proa-button
        :disabled="innerRequesting || requesting"
        @click.native="close"
        class="mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        :loading="innerRequesting || requesting"
        @click.native="onClickRegister"
        variant="primary"
      >
        {{ $t('common.register') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
import iframeSrcFactory from './iframeSrcFactory'

export default {
  name: 'PaymentMethodEditModal',
  props: {
    modal: Boolean,
    paymentSystem: Object,
    paymentSystemMaster: Object,
    requesting: Boolean,
    title: String
  },
  data() {
    return {
      iframeSrc: '',
      fetchPaymentTokenInterval: null,
      innerRequesting: false
    }
  },
  methods: {
    close: function() {
      if (this.innerRequesting || this.requesting) return
      this.$emit('close')
    },
    onClickRegister: function() {
      this.innerRequesting = true
      this.$refs.paymentMethodFormIframe.contentDocument.getElementById('doPurchaseButton').onclick()
    }
  },
  watch: {
    modal: function(value) {
      if (value) {
        this.iframeSrc = iframeSrcFactory({
          paymentSystem: this.paymentSystem,
          paymentSystemMaster: this.paymentSystemMaster
        })
        this.fetchPaymentTokenInterval = setInterval(() => {
          if (!this.$refs.paymentMethodFormIframe) return
          const systemToken = this.$refs.paymentMethodFormIframe.contentDocument.getElementsByName('payment-token')[0].content

          if (systemToken) {
            const cardType = this.$refs.paymentMethodFormIframe.contentDocument.getElementsByName('card-type')[0].content
            const expirationDate = this.$refs.paymentMethodFormIframe.contentDocument.getElementById('ed').value.replace(/[^0-9]+/i, '')
            const lastDigits = this.$refs.paymentMethodFormIframe.contentDocument.getElementById('cn').value.slice(-4)
            const holderFirstName = this.$refs.paymentMethodFormIframe.contentDocument.getElementById('fn').value
            const holderLastName = this.$refs.paymentMethodFormIframe.contentDocument.getElementById('ln').value
            const paymentEmail = this.$refs.paymentMethodFormIframe.contentDocument.getElementById('email').value
            const paymentPhone = this.$refs.paymentMethodFormIframe.contentDocument.getElementById('phoneNumber').value

            clearInterval(this.fetchPaymentTokenInterval)

            // NOTE: API側のporam名に合わせる
            this.$emit('createdPaymentToken', {
              cardType: cardType,
              holderFirstName: holderFirstName,
              holderLastName: holderLastName,
              lastDigits: lastDigits,
              paymentEmail: paymentEmail,
              paymentPhone: paymentPhone,
              systemToken: systemToken,
              validityMonth: expirationDate.slice(0, 2),
              validityYear: expirationDate.slice(2, 4)
            })
          }

          const endInnerLoading = this.$refs.paymentMethodFormIframe.contentDocument.getElementsByName('end-loading')[0].content
          if (endInnerLoading) {
            this.innerRequesting = false
            this.$refs.paymentMethodFormIframe.contentDocument.getElementsByName('end-loading')[0].content = ''
          }
        }, 1000)
      } else {
        if (this.fetchPaymentTokenInterval) clearInterval(this.fetchPaymentTokenInterval)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.payment-method-form-iframe {
  width: 100%;
  height: 100%;
  border: none;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
